module.exports = __webpack_public_path__ + "static/media/material-spandex.2ea30ca9.svg";